import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
export function parseJsonValue(value, context) {
    if (!value) {
        return null;
    }
    try {
        return JSON.parse(value);
    }
    catch (error) {
        console.error(`Invalid JSON data for ${context}.`, error);
        return null;
    }
}
function parseProps(element, propsDataKey) {
    return parseJsonValue(element.dataset[propsDataKey], element.id || element.tagName);
}
export function onDocumentReady(callback) {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
        return;
    }
    callback();
}
export function mountReactComponent({ Component, eventName, getProps, mountedDataKey, propsDataKey = "componentProps", selector }) {
    const mountAll = () => {
        document.querySelectorAll(selector).forEach((element) => {
            if (element.dataset[mountedDataKey] === "true") {
                return;
            }
            const props = getProps?.(element) ?? parseProps(element, propsDataKey);
            if (!props) {
                return;
            }
            element.dataset[mountedDataKey] = "true";
            createRoot(element).render(_jsx(React.StrictMode, { children: _jsx(Component, { ...props }) }));
        });
    };
    onDocumentReady(mountAll);
    if (eventName) {
        window.addEventListener(eventName, mountAll);
    }
    return mountAll;
}
